module.exports = __webpack_public_path__ + "static/media/bharathgourisettibg.fedeb8d2.png";